import React from "react";
import { connect } from "react-redux";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { DragDropContext } from "react-beautiful-dnd";
import { AppAside } from "@coreui/react";
import { Container } from "reactstrap";
import { cmsActions } from "../../../../../store/actions/cms/cms.action";
import { emailActions } from "../../../../../store/actions/cms/email/email.action";
import { systemLabelActions } from "../../../../../store/actions/system/systemLabel/systemLabel.action";
import { emailHelper } from "../../helper/email.helper";
import EmailContent from "./EmailContent";
import EditorSidebar from "../../../../components/editor/EditorSidebar/EditorSidebar";
import { SplashScreen } from "../../../../components/UI/SplashScreen/SplashScreen";
import { sourceTypes } from "../../../../../constants/cms/sourceType";
import { deepClone } from "../../../../../helpers/objectHelper";
import "../../../../style/EditorLayout.css";
import AlertDialog from "../../../../../global/AlertDialog";
import { getKey } from "../../../../../helpers/UrlHelper";
import validateColor from "validate-color";

class EmailEditor extends React.Component {
  state = {
    loaded: false,
    sidebarOpen: true,
  };
  componentDidMount() {
    const { dispatch, user, match } = this.props;
    let eventId = null;
    let languageCode = null;
    if (window.location.search) {
      const params = new URLSearchParams(window.location.search);
      let unparsedEventId = params.get(getKey("eventId", params));
      if (unparsedEventId) eventId = parseInt(unparsedEventId);
      languageCode = params.get(getKey("languageCode", params));
    }
    if (user && !eventId) {
      eventId = user.eid === undefined ? user.token.eid : user.eid;
    }
    if (user && !languageCode) {
      languageCode = user.userLang === undefined ? user.token.userLang : user.userLang;
    }
    if (!languageCode) languageCode = "swe";

    dispatch(emailActions.get(match.params.id));
    dispatch(cmsActions.setEnviroment(sourceTypes.EMAIL, true, eventId, languageCode));
    dispatch(systemLabelActions.getGroup(languageCode, "Email.Edit"));
  }
  componentDidUpdate(prevProps) {
    const { lastFetched, email, template, dispatch } = this.props;
    if (email.templateId && prevProps.email.templateId !== email.templateId) {
      dispatch(templateActions.get(email.templateId));
    }
    if (lastFetched !== null && template !== undefined && this.state.loaded === false) {
      this.setState({ loaded: true });
    }
  }
  sortElements = (result) => {
    const { destination, source, draggableId } = result;
    const { dispatch, email } = this.props;
    const newEmail = deepClone(email);
    const sourceElement = newEmail.elements.find((el) => {
      return el.id === parseInt(draggableId);
    });
    const sortedElements = emailHelper.sortElementOnChange(newEmail.elements, sourceElement, destination, source);
    dispatch(emailActions.updateEmailElement(sortedElements, null, true, this.props.inherit));
  };
  moveElement = (result) => {
    const { destination, source, draggableId } = result;
    const { dispatch, email, template } = this.props;

    const elementType = draggableId;
    let elements = Array.from(email.elements);
    elements = emailHelper.incrementList(email.elements, destination);
    const newElement = emailHelper.createElement(elementType, elements, destination, template.content);

    elements.push(newElement);
    dispatch(emailActions.updateEmailElement(elements, null, true, this.props.inherit));
  };
  onDragEnd = (result) => {
    const { destination, source, draggableId } = result;
    const { elements, dispatch } = this.props;

    if (!destination) {
      return;
    } else if (destination.droppableId === source.droppableId && destination.index === source.index) {
      return;
    } else if (destination.droppableId === "content" && source.droppableId === "content") {
      this.sortElements(result);
    } else if (destination.droppableId.includes("content") && source.droppableId.includes("sidebar")) {
      this.moveElement(result);
    }
    dispatch(cmsActions.blockDeselect(false));
  };
  render() {
    const { loaded } = this.state;
    const { template } = this.props;
    return (
      <React.Fragment>
        {!loaded && <SplashScreen />}
        <DragDropContext onDragEnd={this.onDragEnd}>
          <div className="app form-editmode">
            <div className="app-body" style={{ marginTop: "0px" }} />
            <AppAside className="editor-aside" fixed display="lg" style={{ width: "320px" }} className={"aside-show"}>
              <div ref={(r) => (this.asideEditorRef = r)}>
                <EditorSidebar />
              </div>
            </AppAside>
            <main
              className=" not-inflicted editor-content"
              style={{
                width: "calc(100% - 320px)",
                height: "100vh",
                overflowY: "scroll",
                maxHeight: "100vh",
                marginLeft: this.state.sidebarOpen ? "320px" : "0px",
                backgroundColor: template ? (validateColor(template.content.main.background) ? template.content.main.background : template.content.main.backgroundColor) : "#fff",
              }}
            >
              <Container
                fluid
                style={{
                  padding: "0px",
                  height: "100%",
                }}
              >
                <EmailContent sidebarRef={this.sidebarRef} asideEditorRef={this.asideEditorRef} />
              </Container>
            </main>
          </div>
        </DragDropContext>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
    email: state.email,
    inherit: state.email.inherit,
    template: state.template.template,
    language: state.language,
    lastFetched: state.email.lastFetched,
    systemLabel: state.systemLabel,
  };
}
export default connect(mapStateToProps)(EmailEditor);
